import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { showCustomToast } from "../components/CustomToast";
import { BILLINGS_PAGE_PATH } from "../middleware/routes";
import { getBillingLocationsThunk } from "../reducers/billingLocationsReducer";
import { getBillingThunk, resetBillingState } from "../reducers/billingReducer";
import { useAppDispatch } from "../store";

export const useFetchBillingData = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const id = Number(searchParams.get("id"));

      if (!id) {
        history.push(BILLINGS_PAGE_PATH);
        return;
      }

      dispatch(resetBillingState());
      dispatch(getBillingLocationsThunk(id));
      const result = await dispatch(getBillingThunk(id));

      if (getBillingThunk.rejected.match(result)) {
        history.push(BILLINGS_PAGE_PATH);
        showCustomToast(`${t(`billingApiErrors.${result.payload}`)}`, { type: "error" });
      }
    };

    fetchData();
  }, [dispatch]);
};
